import {Component, Input, OnInit} from "@angular/core";
import {AbstractControl, UntypedFormControl, Validators} from "@angular/forms";

export interface SelectOption {
  label: string;
  value: string;
}

@Component({
    selector: 'app-input-select',
    template: `
      <label class="text-xs m-0" [for]="name">{{ label ?? name + "_label" | i18next }}@if(isRequired){*}</label>
      @if (options && options.length > 0) {
        <p-select
          [options]="options"
          [optionLabel]="optionLabel"
          [optionValue]="optionValue"
          [formControl]="formControl"
          [readonly]="disabled"
        ></p-select>
      }
      <app-input-error-message [control]="formControl" [name]="name"></app-input-error-message>
      `,
    styleUrls: [],
    standalone: false
})

export class InputSelect {
  @Input() control: AbstractControl | UntypedFormControl;
  @Input() options: any;
  @Input() name: string;
  @Input() label?: string;
  @Input() optionLabel? = 'label';
  @Input() optionValue? = 'value';
  @Input() disabled = false;

  get formControl() {
    return this.control as UntypedFormControl;
  }

  get isRequired() {
    return this.control.hasValidator(Validators.required);
  }
}